import {ArrayUtils} from '@colonist/utils'
import {BaseCardData} from '@colonist/game-card-types'
import * as Card from './CardDataList'
import {CardEnum, CardTypeEnum} from '@colonist/game-states'

export class CardDataController {
    static cardDataList: BaseCardData[] = [
        new Card.CardResourceBack(), new Card.CardLumber(), new Card.CardBrick(), new Card.CardWool(), new Card.CardGrain(), new Card.CardOre(),
        new Card.CardAnyResource(),

        new Card.CardDevelopmentCardBack(), new Card.CardKnight(), new Card.CardVictoryPoint(), new Card.CardMonopoly(), new Card.CardRoadBuilding(), new Card.CardYearOfPlenty(),

        new Card.CardCommodityBack(), new Card.CardCommodityCloth(), new Card.CardCommodityCoin(), new Card.CardCommodityPaper(),

        new Card.CardProgressScienceCardBack(), new Card.CardProgressScienceAlchemist(), new Card.CardProgressScienceCrane(), new Card.CardProgressScienceEngineer(),
        new Card.CardProgressScienceInventor(), new Card.CardProgressScienceIrrigation(), new Card.CardProgressScienceMedicine(),
        new Card.CardProgressScienceMining(), new Card.CardProgressSciencePrinter(), new Card.CardProgressScienceRoadBuilding(), new Card.CardProgressScienceSmith(),

        new Card.CardProgressPoliticsCardBack(), new Card.CardProgressPoliticsBishop(), new Card.CardProgressPoliticsConstitution(),
        new Card.CardProgressPoliticsDeserter(), new Card.CardProgressPoliticsDiplomat(), new Card.CardProgressPoliticsIntrigue(),
        new Card.CardProgressPoliticsSaboteur(), new Card.CardProgressPoliticsSpy(), new Card.CardProgressPoliticsWarlord(),
        new Card.CardProgressPoliticsWedding(),

        new Card.CardProgressTradeCardBack(), new Card.CardProgressTradeCommercialHarbor(), new Card.CardProgressTradeMasterMerchant(),
        new Card.CardProgressTradeMerchant(), new Card.CardProgressTradeMerchantFleet(), new Card.CardProgressTradeResourceMonopoly(),
        new Card.CardProgressTradeCommodityMonopoly(),
        new Card.CardProgressBack(),
        new Card.CardResourceOverLimit(),
    ]

    static getCardDataForCard(cardEnum: CardEnum, copy: boolean = true): BaseCardData | undefined {
        for(const card of CardDataController.cardDataList) {
            if(card.cardEnum == cardEnum) return copy ? card.getNewInstanceOfData() : card
        }
        return undefined
    }

    static getBaseCardDataForType(cardTypes: CardTypeEnum[]): BaseCardData[] {
        const cardEnums = CardDataController.getCardEnumsOfTypes(cardTypes)
        const cardDataForType: BaseCardData[] = []
        for(const cardEnum of cardEnums) {
            const cardData = CardDataController.getCardDataForCard(cardEnum)
            if(cardData == undefined) continue
            cardDataForType.push(cardData)
        }
        return cardDataForType
    }

    static getCardTypeFromCardEnum(cardEnum: CardEnum): CardTypeEnum | undefined {
        const cardData = this.getCardDataForCard(cardEnum, false)
        if(!cardData) return undefined

        const cardType = cardData.cardTypeEnum
        return cardType
    }

    static getCardBackOfCard(cardEnum: CardEnum): CardEnum | undefined {
        const cardData = CardDataController.getCardDataForCard(cardEnum)
        if(cardData == undefined) return undefined
        for(const card of CardDataController.cardDataList) {
            if(card.cardTypeEnum != cardData.cardTypeEnum) continue
            if(!card.isCardBack) continue

            return card.cardEnum
        }
        return undefined
    }

    static getCardEnumsOfTypes(cardTypes: CardTypeEnum[]): CardEnum[] {
        const cardEnums: CardEnum[] = []
        for(const card of CardDataController.cardDataList) {
            if(card.isCardBack) continue
            if(!ArrayUtils.elementInArray(cardTypes, card.cardTypeEnum)) continue
            cardEnums.push(card.cardEnum)
        }
        return cardEnums
    }

    static areCardsValidInputForType(cardsToCheck: CardEnum[], validCardTypes: CardTypeEnum[]): boolean {
        const uniqueCardsToCheck = ArrayUtils.removeDuplicatesFromArray(cardsToCheck)
        for(const cardEnum of uniqueCardsToCheck) {
            const cardData = CardDataController.getCardDataForCard(cardEnum)
            if(cardData == undefined) continue
            if(cardData.isCardBack) return false
            if(!ArrayUtils.elementInArray(validCardTypes, cardData.cardTypeEnum)) return false
        }
        return true
    }

    static isResourceCard(cardEnum: CardEnum): boolean {
        const cardData = CardDataController.getCardDataForCard(cardEnum)
        if(cardData == undefined) return false

        if(cardData.cardTypeEnum == CardTypeEnum.Resource) return true
        if(cardData.cardTypeEnum == CardTypeEnum.Commodity) return true

        return false
    }

    static getCardBacksForCards(cardEnums: CardEnum[]): CardEnum[] {
        const cardBacks: CardEnum[] = []
        for(const cardEnum of cardEnums) {
            const cardBack = this.getCardBackOfCard(cardEnum)
            if(cardBack == undefined) continue
            cardBacks.push(cardBack)
        }
        return cardBacks
    }
}
